import React from 'react';
import Dotdotdot from 'react-dotdotdot';

import ProductReview from '../../product/components/product-review';
import ProductImage from '../../product/components/product-image';
import Modal from '../../shared/components/modal';
import Link from '../../ui/components/link';

import { Helpers } from '../../core/src/helpers';
import '../css/dlp-reviews.less';

class DLPReviews extends React.PureComponent{

    state = {
        modalProduct: null
    };

    toggleModalView = (product) => this.setState({ modalProduct: product });

    renderProductImage = ({images}) => images;

    renderProductReview = (product, isModal) => {
        let { reviews, images, sku, name, linkUrl } = product || {};
        let { text, rating, user, lastSubmissionTime } = reviews && reviews[0] ? reviews[0] : {};
        let image = images && images[0];
        let reviewedProduct = {
            rating
        };
        return text && text.length > 0 && (
            <div key={`dlp-review-${sku}`} className="dlp-reviews-tile">
                <div className="dlp-reviews-image-container">
                        <ProductImage 
                            product={{
                                images: [image],
                                sku, 
                                name
                            }} 
                            link={linkUrl} 
                            linkType='relative'
                            lazyLoad={true} 
                            maxImgWidth={270}
                            ImageWrapper={this.renderProductImage}
                        />
                    </div>
                    <div className="dlp-reviews-summary-container">
                        <h1>{name}</h1>
                        <div className="dlp-rating-container product-card-detail">
                            <div className="reviews-row product-review">
                                <ProductReview product={reviewedProduct} displayAvgRating hideReviewCount/>
                            </div>
                        </div>
                        {
                            isModal 
                            ? <div className="dlp-review-summary-container">{text}</div>
                            : <div className="dlp-review-summary-container">
                                <Dotdotdot clamp={5}>
                                    <span>{text}</span>
                                </Dotdotdot>
                              </div>
                        }
                        { 
                            isModal ? (
                                <div className="dlp-review-user-info"> <div className="dlp-review-user">{user}</div> {lastSubmissionTime ? <div>{`${new Date(lastSubmissionTime).toLocaleDateString()}`}</div> : ''}</div>
                            ) : (
                                <Link className="with-hover" onClick={()=>this.toggleModalView(product)}>READ THE REVIEW</Link>
                            )
                        }
                    </div>
            </div>
        );
    } 

    getProductReviews = Helpers.memoize( results => {

        try{
            return (
                results.reduce( (productReviews, product ) => {
                    let productReview;
                    if(productReviews.length < 4){
                        productReview = this.renderProductReview(product);
                    }
        
                    if(productReview){
                        productReviews.push(productReview);
                    }
                    return productReviews;
                }, [])
            );
        }catch(e){}

        return null;
    }, (results, keyword) => `${keyword}-${results && results.length}`);

    render(){
        let { results, keyword } = this.props;
        let { modalProduct } = this.state;
        let reviews = this.getProductReviews(results, keyword);
        return reviews && reviews.length >= 2 && (
            <div className="dlp-reviews-wrapper">
                <div className="dlp-reviews-container">
                    { keyword && keyword.length > 0 && <h2 className="dlp-reviews-header">{`Recent ${keyword} Reviews`}</h2> }
                    <div className="dlp-reviews">{ reviews }</div>
                    <Modal  isOpen={!!modalProduct} className="dlp-review-modal" closeModal={()=>this.toggleModalView(null)}>
                            { this.renderProductReview(modalProduct, true) }
                    </Modal>
                </div>
            </div>
        );
    }
}

export default DLPReviews;